var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessPointIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_66_1325)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "#DF924A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3196 10C9.58332 10.7342 8.99937 11.6066 8.6013 12.5671C8.20323 13.5276 7.99889 14.5573 8 15.5971C8 17.7821 8.88667 19.7612 10.3196 21.1942L11.4358 20.0779C10.8457 19.4909 10.378 18.7926 10.06 18.0234C9.74202 17.2541 9.57999 16.4294 9.58334 15.5971C9.58334 13.8475 10.2879 12.2563 11.4358 11.1163L10.3196 10ZM21.5138 10L20.3975 11.1163C20.987 11.7037 21.4543 12.4021 21.7723 13.1712C22.0902 13.9403 22.2526 14.7648 22.25 15.5971C22.25 17.3546 21.5454 18.9379 20.3975 20.0779L21.5138 21.1942C22.25 20.46 22.834 19.5876 23.232 18.6271C23.6301 17.6666 23.8345 16.6368 23.8333 15.5971C23.8333 13.4121 22.9467 11.4329 21.5138 10ZM12.56 12.2404C12.1181 12.6806 11.7675 13.2037 11.5284 13.7797C11.2893 14.3558 11.1664 14.9734 11.1667 15.5971C11.1667 16.9033 11.6971 18.0908 12.56 18.9537L13.6763 17.8375C13.3819 17.5435 13.1486 17.1942 12.9896 16.8097C12.8307 16.4252 12.7492 16.0131 12.75 15.5971C12.75 14.7183 13.1063 13.9267 13.6763 13.3567L12.56 12.2404ZM19.2733 12.2404L18.1571 13.3567C18.4514 13.6507 18.6848 14 18.8437 14.3845C19.0027 14.769 19.0841 15.181 19.0833 15.5971C19.0833 16.4758 18.7271 17.2675 18.1571 17.8375L19.2733 18.9537C19.7152 18.5136 20.0658 17.9905 20.3049 17.4144C20.5441 16.8384 20.667 16.2208 20.6667 15.5971C20.6667 14.2908 20.1363 13.1033 19.2733 12.2404ZM15.9167 14.0138C15.4967 14.0138 15.094 14.1806 14.7971 14.4775C14.5002 14.7744 14.3333 15.1772 14.3333 15.5971C14.3333 16.017 14.5002 16.4197 14.7971 16.7167C15.094 17.0136 15.4967 17.1804 15.9167 17.1804C16.3366 17.1804 16.7393 17.0136 17.0363 16.7167C17.3332 16.4197 17.5 16.017 17.5 15.5971C17.5 15.1772 17.3332 14.7744 17.0363 14.4775C16.7393 14.1806 16.3366 14.0138 15.9167 14.0138Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_66_1325",
    x: 0,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_66_1325"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_66_1325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_66_1325",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessPointIcons);
export default __webpack_public_path__ + "static/media/AccessPointIcons.db7f105d9770f9a212c08f6506f3b662.svg";
export { ForwardRef as ReactComponent };